import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import "./UpgradePopup.css"
import edit from "../../assets/person_edit.svg"
import { Typography } from '../../design_system/StyledComponents/components/Typography';
import { Check, Close } from '@mui/icons-material';
import PercentIcon from '@mui/icons-material/Percent';
import { Button } from '../../design_system/StyledComponents/components/Button';
import { setShowPaymentConfirmationPopup, setShowUpgradePopup } from '../../Actions/ApplicationStateAction';
import { fetchWrapper } from '../../app/RomeDataManager';

const UpgradePopup = () => {
    const { showUpgradePopup,  id, projecId } = useSelector((state) => state.ApplicationState);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        dispatch(setShowUpgradePopup(false))
    }

    const updateResponse = async (
        razorpay_payment_id,
        razorpay_order_id,
        razorpay_signature,
        razorpay_subscription_id
      ) => {
        var formData = new FormData();
        formData.append("payment_id", razorpay_payment_id);
        formData.append("order_id", razorpay_order_id);
        formData.append("signature", razorpay_signature);
        formData.append("subscription_id", razorpay_subscription_id);
      
        const res = await fetchWrapper
          .post("/orders/confirm", formData)
          .then((result) => {
            if (result.statusText !== "OK" || result.data.error) {
              return;
            }
      
            // window.location.reload();
          });
        return res;
      };

    const handleCheckoutClick = async () => {
        setLoading(true);
        let formData = new FormData();
        formData.append("plan_id", process.env.REACT_APP_RAZORPAY_PLAN_ID);
        formData.append("tenure_type", "month");
        formData.append("unit_count", "1");
        formData.append("floorplan_id", id);
        formData.append("project_id", projecId);
        const result = await fetchWrapper.post("/floorplan_subscriptions/subscription_plan", formData);
        let form = new FormData();
        form.append("floorplan_id", id);
        form.append("project_id", projecId);
        const res = await fetchWrapper.post("/orders/checkout", form)
        setLoading(false);
        let response = res.data
        var options = {
            key: response.key, // Enter the Key ID generated from the Dashboard
            amount: response.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: response.currency,
            name: "Superbolt Technologies Pvt Ltd",
            description: response.description,
            image: "/Images/logo-500_500.png",
            // order_id: response.order_id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            // subscription_id: response.subscription_id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            subscription_id: response.subscription_id || "",
            order_id: response.order_id || "",
            handler: async function (res) {
              setLoading(true);
              /*previous location*/
              window.gtag("event", "purchase", {
                transaction_id: res.razorpay_payment_id,
                value: response.total_amount / 100,
                tax: 0,
                shipping: 0,
                currency: response.currency,
                coupon: "",
                items: [
                  {
                    item_id: "",
                    item_name: "Floorplan Subscription",
                    affiliation: "",
                    coupon: "",
                    discount: response.discount_amount,
                    index: 0,
                    item_brand: "Superbolter",
                    item_category: "Floorplan",
                    item_category2: "",
                    item_category3: "",
                    item_category4: "",
                    item_category5: "",
                    item_list_id: "",
                    item_list_name: "",
                    item_variant: "",
                    location_id: "",
                    price: response.total_amount / (100 * response.unit_count),
                    quantity: response.unit_count
                  },
                ],
              });
              await updateResponse(
                res.razorpay_payment_id,
                res.razorpay_order_id || "",
                res.razorpay_signature,
                res.razorpay_subscription_id || ""
              );
              setLoading(false);
              // console.log(data,popupDataObj
              handleClose();
              dispatch(setShowPaymentConfirmationPopup(true));
            },
            prefill: {
              name: response.name,
              email: response.email,
              contact: response.contact,
            },
            notes: {
              address: response.address,
            },
            theme: {
              color: "#F37254",
            },
          };
        const razp = new window.Razorpay(options);
        razp.open();
    }
    return (
        showUpgradePopup &&
        <div className='upgrade-popup-container'>
            <div className="upgrade-popup-content">
                <div className="upgrade-popup-close">
                    <Close
                        style={{ cursor: "pointer", color: "black" }}
                        onClick={handleClose}
                    />
                </div>
                <img src={edit} alt="edit" />
                <div>
                    <Typography modifiers={["header5", "bold"]}>Hire a drawing expert</Typography>
                    <Typography modifiers={["subtitle1"]}>We will draw your floorplan for you!</Typography>
                </div>
                <hr />
                <div className='upgrade-popup-points'>
                    <div className='upgrade-popup-checks'>
                        <div className='upgrade-popup-check'>
                            <Check style={{ color: "#E1544E", fontSize: "18px" }} />
                            <Typography>Get 3d model within 1 business day</Typography>
                        </div>
                        <div className='upgrade-popup-check'>
                            <Check style={{ color: "#E1544E", fontSize: "18px" }} />
                            <Typography>Assistance even after drawing is completed</Typography>
                        </div>
                        <div className='upgrade-popup-check'>
                            <Check style={{ color: "#E1544E", fontSize: "18px" }} />
                            <Typography>Full refund if you are not happy with the 3D</Typography>
                        </div>
                    </div>
                </div>
                <hr />
                <div className='upgrade-popup-price'>
                    <Typography style={{textDecoration:"line-through", color:"#6E757A"}} modifiers={["header5", "bold"]}>₹1,999</Typography>
                    <Typography modifiers={["header4", "bold"]}>₹999</Typography>
                    <div className='upgrade-popup-price-off'>
                        <Typography modifiers={["header5", "medium"]}>50%</Typography>
                        <Typography modifiers={["uppercase", "medium", "subtitle1"]}>OFF</Typography>
                        <div><PercentIcon style={{fontSize: "14px"}} /></div>
                    </div>
                </div>
                <Button requesting={loading} onClick={handleCheckoutClick} modifiers={["primary", "block"]}>Pay</Button>
            </div>
        </div>
    )
}

export default UpgradePopup
